<div class="container mb-5 modulo">
  <div class="row">
    <div class="col-12 mx-auto" align="center">
      <span [innerHTML]="campi.LINK?.valore | safe"></span>
    </div>
  </div>
</div>